<template>
  <form-group v-bind="$attrs">
    <v-row>
      <v-col cols="6">
        <input-radio
          v-model="value.indKit"
          :options="indKitOptions"
          label="Kit"
          row
        />
      </v-col>
      <v-col cols="6">
        <input-text
          v-if="isKit"
          id="input:qtdItemsNoKit"
          v-model="qtdItemsNoKit"
          label="Quantidade de items"
          type="number"
          :required="isKit"
          :rules="isKit ? [requiredRule] : []"
          @blur="emit('qtdItemsNoKit', $event)"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'ChipCategory',
  components: { FormGroup },
  mixins: [RulesMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          indKit: '',
          qtdItemsNoKit: '',
        };
      },
    },
  },
  data: () => ({
    indKitOptions: [
      {
        value: true,
        label: 'Sim',
      },
      {
        value: false,
        label: 'Não',
        color: 'primary',
      },
    ],
  }),
  computed: {
    qtdItemsNoKit: {
      get() {
        return this.value.qtdItemsNoKit;
      },
      set(v) {
        return v;
      },
    },
    emit() {
      return (property, ev) => {
        const { value } = ev.target;
        this.value[property] = value;
      };
    },
    isKit() {
      return this.value.indKit;
    },
  },
};
</script>
